import { ChevronDown } from 'lucide-react';

import { Container } from '../ui/Container';

export function Hero(): JSX.Element {
  return (
    <section className="relative isolate flex min-h-[88vh] items-center overflow-hidden bg-brand-charcoal text-brand-white">
      <picture>
        <source
          type="image/webp"
          srcSet="/photos/image4-800.webp 800w, /photos/image4-1600.webp 1600w"
          sizes="100vw"
        />
        <img
          src="/photos/image4-1600.webp"
          alt="Aerial view of Sunset Harbor Condominiums on the Banana River in Cocoa Beach, a five-story waterfront building with palm-lined entry, rooftop wordmark, and adjacent marina."
          className="absolute inset-0 -z-10 h-full w-full object-cover object-bottom opacity-90"
          loading="eager"
          fetchPriority="high"
        />
      </picture>
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-b from-brand-black/50 via-brand-black/30 to-brand-black/70"
        aria-hidden="true"
      />

      <Container width="wide" className="py-32 md:py-40">
        <div className="max-w-3xl">
          <p className="mb-5 text-sm font-medium uppercase tracking-[0.22em] text-brand-yellow">
            Cocoa Beach, Florida
          </p>
          <h1 className="text-display-md font-bold tracking-heading-display text-brand-white md:text-display-lg lg:text-display-xl">
            Sunset Harbor
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-brand-white/90 md:text-xl">
            Forty-five waterfront homes on the Banana River. Two blocks to the Atlantic.
          </p>
        </div>
      </Container>

      <a
        href="#marquee"
        aria-label="Scroll to content"
        className="absolute inset-x-0 bottom-8 mx-auto flex w-fit items-center gap-2 text-xs uppercase tracking-[0.22em] text-brand-white/70 transition-colors hover:text-brand-yellow"
      >
        Scroll
        <ChevronDown size={16} className="animate-bounce" />
      </a>
    </section>
  );
}
